import Vue from 'vue';
import mixin from './mixin.js';
import Fragment from 'vue-fragment';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import store from '@/store/AppStore';

require(`./assets/${process.env.VUE_APP_BRAND}/scss/_fonts.scss`);
Vue.use(Fragment.Plugin);

window.startupTSVue = new Date().getTime();
if (window.initialData.logins) {
	// JSON.parse required because BE can't print \n they only can do \\n if we want predefined line-breaks HOMEPAGE-3689
	window.initialData.logins = JSON.parse(JSON.stringify(window.initialData.logins).replace('\\\\n', '\\n'));
}

store.commit('setAdServiceParams', window.initialData.serviceResponse._params);

if (window.PageConfig.site === 'hp') {
	store.commit('setAdData', window.initialData.serviceResponse.response);
	store.commit('setAgent', window.initialData.serviceResponse.agent);
} else {
	store.commit('setRequestData', window.initialData.request);
	window.initialData.request = undefined;
}

store.commit('setContentData', window.initialData);

new Vue({
	el: '#app',
	mixins: [mixin],
	store,
	components: {
		'hp-app': require('./App.vue').default
	}
});

// add sentry if not on localhost (too much spam) and if we have permissions to use sentry
if (!window.PageConfig.stage.includes('local')) {
	window.__tcfapi(
		'getPermission',
		2,
		(response) => {
			if (!response) {
				return;
			}

			const dsn =
				window.PageConfig.stage.includes('qa') || window.PageConfig.stage.includes('dev')
					? 'https://da71f05e3dbb4eb8b981a7f4c314e3c5@caproxy-hp-qa.ui-portal.de/sentry/1'
					: 'https://1b92faabe499480db487f7684547c792@caproxy-hp.ui-portal.de/sentry/1';

			Sentry.init({
				Vue,
				dsn,
				integrations: [new Integrations.Vue({ Vue, attachProps: true })]
			});
		},
		'sentryErrorTracing'
	);
}
